export const SET_RESOURCE_LIST = 'SET_RESOURCE_LIST';
